import React, { useEffect, useState } from "react";
import axios from "../../../axios";
import OfflineCompletedBoxList from "./OfflineCompletedBoxList";

function OfflineCompletedBox({ filter }) {
  const [completedAssessmentList, setCompletedAssessmentList] = useState([]);
  let teacher_id = JSON.parse(localStorage.getItem("Teacher_id"));
  const [isGettingData, setIsGettingData] = useState(true);

  const timeTableSessionId = JSON.parse(
    localStorage.getItem("timeTableSessionId"),
  );

  const academicSessionId = JSON.parse(
    localStorage.getItem("academicYearSessionId"),
  );

  const getCompletedAssessment = async () => {
    setIsGettingData(true);
    try {
      let res = await axios.get(
        `/api/v1/assessment/filterByTeacherId/${teacher_id}/completed?sortBy=-1&_page=1&_limit=100&offlineMode=true&academicSessionId=${academicSessionId}&timetableSessionId=${timeTableSessionId}` +
          `${filter?.standard_id ? `&standardId=${filter?.standard_id}` : ""}` +
          `${filter?.searchvalue ? `&name=${filter?.searchvalue}` : ""}` +
          `${filter?.section_id ? `&sectionId=${filter?.section_id}` : ""}` +
          `${filter?.date ? `&date=${filter?.date}` : ""}` +
          `${filter?.time ? `&time=${filter?.time}` : ""}` +
          `${filter?.subjectId?.length > 0 ? `&subjectId=${filter?.subjectId}` : ""}`,
      );
      res && setCompletedAssessmentList(res.data.data);
    } catch (error) {
      console.log(error);
    } finally {
      setIsGettingData(false);
    }
  };

  useEffect(() => {
    getCompletedAssessment();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter]);

  return (
    <div className="w-100">
      <OfflineCompletedBoxList
        assessments={completedAssessmentList}
        isLoading={isGettingData}
      />
    </div>
  );
}

export default OfflineCompletedBox;
